export default __webpack_public_path__ + "static/media/announcement_2@3x.50f4232e.png";